import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { colors } from "@src/theme";
import Logo from "@src/components/Logo";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  root: {
    [breakpoints.up("md")]: {
      paddingTop: spacing(6.25),
      marginTop: 0,
    },
    [breakpoints.down("xs")]: {
      paddingTop: spacing(3),
      marginTop: 0,
    },
  },
  arrowIcon: {
    height: 48,
    width: 48,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.primarySkin,
    borderRadius: "24px",
    cursor: "pointer",
    [breakpoints.up("md")]: {
      marginRight: spacing(33),
    },
    [breakpoints.down("xs")]: {
      marginRight: spacing(8),
    },
  },
  logoCenter: {
    minHeight: 28,
  },
}));

const TopBar = ({ moveToPrevStep }) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className={classes.root}
    >
      <Box className={classes.arrowIcon} onClick={moveToPrevStep}>
        <ArrowBackIcon />
      </Box>
      <Link to="/">
        <Logo className={classes.logoCenter} />
      </Link>
    </Box>
  );
};

export default TopBar;
